import React from 'react';
// Constants
import {
  CompanyTagLine,
  CompanyName,
} from '../../utils/Constants';
// Components
import FooterSocialCTA from './FooterSocialCTA';
// Images
import CompanyMainLogo from '../../assets/images/logos/lady-cender-dominatrix-goddess-logo1.webp';

function FooterComponent() {
  return (
    <footer className='grid bg-colour2 hero-teddy-class w-full overflow-hidden py-6 md:py-12 px-6 md:px-20 font-poppins'>
      <div className='grid mx-auto gap-6 bg-colour1/90 px-2 text-colour5 md:px-10 py-8 w-full'>
        {/* Logo section */}
        <section className='grid h-fit my-auto gap-4 py-2 w-full'>
          <div className='grid items-center justify-center'>
            <img
              src={CompanyMainLogo}
              alt={`${CompanyName} footer logo`}
              className='min-w-6 md:w-60 w-full'
            />
          </div>
          <div className='text-center'>
            <p className='text-sm'>{CompanyTagLine}</p>
          </div>
          <FooterSocialCTA />
        </section>
      </div>
    </footer>
  );
}

export default FooterComponent;
